import React from 'react';
import { DialogContentText } from '@mui/material';
import { create, InstanceProps } from 'react-modal-promise';
import { getPolyglot } from '../../../i18n';
import ReportAPI from '../../../redux/reports/api/ReportAPI';
import { useShowErrorMessage } from '../../../handlingErrors';
import { useAppSelector } from '../../../redux/store.model';
import { getMyWorkspaceIdSelector } from '../../../redux/stoerkID/selectors/StoerkId.selectors';
import { DialogModal } from '../../../theme/components';
import { useShowMessage } from '../../../util/hooks';

interface Props extends InstanceProps<boolean> {
  reportId: string;
}
export function ReportDeleteModalPromise(props: Props) {
  const { onResolve, onReject, isOpen, reportId } = props;
  const polyglot = getPolyglot();
  const workspaceId = useAppSelector(getMyWorkspaceIdSelector);
  const showErrorMessage = useShowErrorMessage();
  const showMessage = useShowMessage();
  const [deleteReport, { isLoading }] =
    ReportAPI.endpoints.deleteReport.useMutation();

  const onSave = () => {
    deleteReport({ reportId, workspaceId })
      .unwrap()
      .then(() => showMessage(polyglot.t('reports.delete.success')))
      .catch(showErrorMessage)
      .finally(() => onResolve(true));
  };

  return (
    <DialogModal
      open={isOpen}
      onClose={() => onReject(false)}
      onConfirm={onSave}
      loading={isLoading}
    >
      <DialogContentText>
        {polyglot.t('reports.delete.description')}
      </DialogContentText>
    </DialogModal>
  );
}

export const openReportDeleteModalAsPromise = create(ReportDeleteModalPromise);
